import { useIsMobile } from "@/hooks/use-mobile";

interface Props {
  mobile?: React.ReactNode | null;
  desktop?: React.ReactNode | null;
}

export default function MobileDesktop({
  mobile = null,
  desktop = null,
}: Props) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return mobile;
  }

  return desktop;
}
